export const buildProvenance = { "commitHash": "a5cb47877aaef1a73dec1c7d1f68aae5dfc37ad5", "branchName": "refs/heads/release/2025.2", "buildDate": "2025-06-23T22:55:52.989Z", "version": "2025.2.12920" };
